import angular from 'angular';

document.write(require('./view.html').default);

angular.module("merchant.application.page.inStore.card.acquirerDetails", [
    "merchant.application.module.acquirers.list",
    "merchant.application.module.acquirers.acquirer",
]).controller("merchant.application.page.inStore.card.acquirerDetails.controller", [
    "$rootScope", "$scope", "$controller",
    function($rootScope, $scope, $controller) {
        $controller("merchant.application.page.inStore.card.controller", {$scope: $scope});

        $scope.openNewAcquirer = function() {
            $scope.$broadcast("newAcquirer");
        };
    }
]);
